"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _ApiClient = _interopRequireDefault(require("../ApiClient"));
var _ForgedToken = _interopRequireDefault(require("../model/ForgedToken"));
var _HTTPError = _interopRequireDefault(require("../model/HTTPError"));
var _HTTPValidationError = _interopRequireDefault(require("../model/HTTPValidationError"));
var _TokenResponse = _interopRequireDefault(require("../model/TokenResponse"));
function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    "default": obj
  };
}
function _classCallCheck(instance, Constructor) {
  if (!(instance instanceof Constructor)) {
    throw new TypeError("Cannot call a class as a function");
  }
}
function _defineProperties(target, props) {
  for (var i = 0; i < props.length; i++) {
    var descriptor = props[i];
    descriptor.enumerable = descriptor.enumerable || false;
    descriptor.configurable = true;
    if ("value" in descriptor) descriptor.writable = true;
    Object.defineProperty(target, descriptor.key, descriptor);
  }
}
function _createClass(Constructor, protoProps, staticProps) {
  if (protoProps) _defineProperties(Constructor.prototype, protoProps);
  if (staticProps) _defineProperties(Constructor, staticProps);
  return Constructor;
}

/**
* Default service.
* @module api/DefaultApi
* @version 0.1.1
*/
var DefaultApi = /*#__PURE__*/function () {
  /**
  * Constructs a new DefaultApi. 
  * @alias module:api/DefaultApi
  * @class
  * @param {module:ApiClient} [apiClient] Optional API client implementation to use,
  * default to {@link module:ApiClient#instance} if unspecified.
  */
  function DefaultApi(apiClient) {
    _classCallCheck(this, DefaultApi);
    this.apiClient = apiClient || _ApiClient["default"].instance;
  }
  /**
   * Delete Token
   * With a GUID being given, it will delete the associated token but raise 404 if guid not previously known
   * @param {String} guid 
   * @param {String} authorization 
   * @return {Promise} a {@link https://www.promisejs.org/|Promise}, with an object containing data of type {@link Object} and HTTP response
   */

  _createClass(DefaultApi, [{
    key: "deleteTokenUserGUIDGuidDeleteWithHttpInfo",
    value: function deleteTokenUserGUIDGuidDeleteWithHttpInfo(guid, authorization) {
      var postBody = null; // verify the required parameter 'guid' is set

      if (guid === undefined || guid === null) {
        throw new Error("Missing the required parameter 'guid' when calling deleteTokenUserGUIDGuidDelete");
      } // verify the required parameter 'authorization' is set

      if (authorization === undefined || authorization === null) {
        throw new Error("Missing the required parameter 'authorization' when calling deleteTokenUserGUIDGuidDelete");
      }
      var pathParams = {
        'guid': guid
      };
      var queryParams = {};
      var headerParams = {
        'Authorization': authorization
      };
      var formParams = {};
      var authNames = [];
      var contentTypes = [];
      var accepts = ['application/json'];
      var returnType = Object;
      return this.apiClient.callApi('/user/GUID/{guid}', 'DELETE', pathParams, queryParams, headerParams, formParams, postBody, authNames, contentTypes, accepts, returnType, null);
    }
    /**
     * Delete Token
     * With a GUID being given, it will delete the associated token but raise 404 if guid not previously known
     * @param {String} guid 
     * @param {String} authorization 
     * @return {Promise} a {@link https://www.promisejs.org/|Promise}, with data of type {@link Object}
     */
  }, {
    key: "deleteTokenUserGUIDGuidDelete",
    value: function deleteTokenUserGUIDGuidDelete(guid, authorization) {
      return this.deleteTokenUserGUIDGuidDeleteWithHttpInfo(guid, authorization).then(function (response_and_data) {
        return response_and_data.data;
      });
    }
    /**
     * Exchange Guid
     * with a GUID being given, it will work as /user/token endpoint but raise 404 if guid not previously known
     * @param {String} guid 
     * @param {Object} opts Optional parameters
     * @param {String} opts.cacheControl 
     * @return {Promise} a {@link https://www.promisejs.org/|Promise}, with an object containing data of type {@link module:model/TokenResponse} and HTTP response
     */
  }, {
    key: "exchangeGuidUserGUIDGuidGetWithHttpInfo",
    value: function exchangeGuidUserGUIDGuidGetWithHttpInfo(guid, opts) {
      opts = opts || {};
      var postBody = null; // verify the required parameter 'guid' is set

      if (guid === undefined || guid === null) {
        throw new Error("Missing the required parameter 'guid' when calling exchangeGuidUserGUIDGuidGet");
      }
      var pathParams = {
        'guid': guid
      };
      var queryParams = {};
      var headerParams = {
        'cache-control': opts['cacheControl']
      };
      var formParams = {};
      var authNames = [];
      var contentTypes = [];
      var accepts = ['application/json'];
      var returnType = _TokenResponse["default"];
      return this.apiClient.callApi('/user/GUID/{guid}', 'GET', pathParams, queryParams, headerParams, formParams, postBody, authNames, contentTypes, accepts, returnType, null);
    }
    /**
     * Exchange Guid
     * with a GUID being given, it will work as /user/token endpoint but raise 404 if guid not previously known
     * @param {String} guid 
     * @param {Object} opts Optional parameters
     * @param {String} opts.cacheControl 
     * @return {Promise} a {@link https://www.promisejs.org/|Promise}, with data of type {@link module:model/TokenResponse}
     */
  }, {
    key: "exchangeGuidUserGUIDGuidGet",
    value: function exchangeGuidUserGUIDGuidGet(guid, opts) {
      return this.exchangeGuidUserGUIDGuidGetWithHttpInfo(guid, opts).then(function (response_and_data) {
        return response_and_data.data;
      });
    }
    /**
     * Exchange Token
     * Delivers the user GUID behind the token, as well as a jwt granting access to the strapi CMS
     * @param {String} token 
     * @param {Object} opts Optional parameters
     * @param {String} opts.cacheControl 
     * @param {String} opts.xEvidencebApp 
     * @return {Promise} a {@link https://www.promisejs.org/|Promise}, with an object containing data of type {@link module:model/TokenResponse} and HTTP response
     */
  }, {
    key: "exchangeTokenUserTokenTokenPostWithHttpInfo",
    value: function exchangeTokenUserTokenTokenPostWithHttpInfo(token, opts) {
      opts = opts || {};
      var postBody = null; // verify the required parameter 'token' is set

      if (token === undefined || token === null) {
        throw new Error("Missing the required parameter 'token' when calling exchangeTokenUserTokenTokenPost");
      }
      var pathParams = {
        'token': token
      };
      var queryParams = {};
      var headerParams = {
        'cache-control': opts['cacheControl'],
        'x-evidenceb-app': opts['xEvidencebApp']
      };
      var formParams = {};
      var authNames = [];
      var contentTypes = [];
      var accepts = ['application/json'];
      var returnType = _TokenResponse["default"];
      return this.apiClient.callApi('/user/token/{token}', 'POST', pathParams, queryParams, headerParams, formParams, postBody, authNames, contentTypes, accepts, returnType, null);
    }
    /**
     * Exchange Token
     * Delivers the user GUID behind the token, as well as a jwt granting access to the strapi CMS
     * @param {String} token 
     * @param {Object} opts Optional parameters
     * @param {String} opts.cacheControl 
     * @param {String} opts.xEvidencebApp 
     * @return {Promise} a {@link https://www.promisejs.org/|Promise}, with data of type {@link module:model/TokenResponse}
     */
  }, {
    key: "exchangeTokenUserTokenTokenPost",
    value: function exchangeTokenUserTokenTokenPost(token, opts) {
      return this.exchangeTokenUserTokenTokenPostWithHttpInfo(token, opts).then(function (response_and_data) {
        return response_and_data.data;
      });
    }
    /**
     * Generate Forged Token
     * Generates a unique token to access /user/token
     * @param {module:model/String} userType Choisissez votre statut :
     * @param {String} firstName Votre prénom :
     * @param {String} lastName Votre nom :
     * @param {String} uaiEtablissement Votre établissement :
     * @param {String} secret Saisissez la clé secrète qui vous a été communiquée :
     * @param {Object} opts Optional parameters
     * @param {Array.<String>} opts.classes Si vous êtes enseignant, ajoutez votre/vos classes :
     * @param {String} opts.classe Si vous êtes élève, mentionnez votre classe :
     * @return {Promise} a {@link https://www.promisejs.org/|Promise}, with an object containing data of type {@link module:model/ForgedToken} and HTTP response
     */
  }, {
    key: "generateForgedTokenGenerateTokenGetWithHttpInfo",
    value: function generateForgedTokenGenerateTokenGetWithHttpInfo(userType, firstName, lastName, uaiEtablissement, secret, opts) {
      opts = opts || {};
      var postBody = null; // verify the required parameter 'userType' is set

      if (userType === undefined || userType === null) {
        throw new Error("Missing the required parameter 'userType' when calling generateForgedTokenGenerateTokenGet");
      } // verify the required parameter 'firstName' is set

      if (firstName === undefined || firstName === null) {
        throw new Error("Missing the required parameter 'firstName' when calling generateForgedTokenGenerateTokenGet");
      } // verify the required parameter 'lastName' is set

      if (lastName === undefined || lastName === null) {
        throw new Error("Missing the required parameter 'lastName' when calling generateForgedTokenGenerateTokenGet");
      } // verify the required parameter 'uaiEtablissement' is set

      if (uaiEtablissement === undefined || uaiEtablissement === null) {
        throw new Error("Missing the required parameter 'uaiEtablissement' when calling generateForgedTokenGenerateTokenGet");
      } // verify the required parameter 'secret' is set

      if (secret === undefined || secret === null) {
        throw new Error("Missing the required parameter 'secret' when calling generateForgedTokenGenerateTokenGet");
      }
      var pathParams = {};
      var queryParams = {
        'userType': userType,
        'first_name': firstName,
        'last_name': lastName,
        'uaiEtablissement': uaiEtablissement,
        'secret': secret,
        'classes': this.apiClient.buildCollectionParam(opts['classes'], 'multi'),
        'classe': opts['classe']
      };
      var headerParams = {};
      var formParams = {};
      var authNames = [];
      var contentTypes = [];
      var accepts = ['application/json'];
      var returnType = _ForgedToken["default"];
      return this.apiClient.callApi('/generate/token', 'GET', pathParams, queryParams, headerParams, formParams, postBody, authNames, contentTypes, accepts, returnType, null);
    }
    /**
     * Generate Forged Token
     * Generates a unique token to access /user/token
     * @param {module:model/String} userType Choisissez votre statut :
     * @param {String} firstName Votre prénom :
     * @param {String} lastName Votre nom :
     * @param {String} uaiEtablissement Votre établissement :
     * @param {String} secret Saisissez la clé secrète qui vous a été communiquée :
     * @param {Object} opts Optional parameters
     * @param {Array.<String>} opts.classes Si vous êtes enseignant, ajoutez votre/vos classes :
     * @param {String} opts.classe Si vous êtes élève, mentionnez votre classe :
     * @return {Promise} a {@link https://www.promisejs.org/|Promise}, with data of type {@link module:model/ForgedToken}
     */
  }, {
    key: "generateForgedTokenGenerateTokenGet",
    value: function generateForgedTokenGenerateTokenGet(userType, firstName, lastName, uaiEtablissement, secret, opts) {
      return this.generateForgedTokenGenerateTokenGetWithHttpInfo(userType, firstName, lastName, uaiEtablissement, secret, opts).then(function (response_and_data) {
        return response_and_data.data;
      });
    }
  }]);
  return DefaultApi;
}();
exports["default"] = DefaultApi;